/**
 * Eigene Rechnungen auf der Kontoseite (seit 07.10.2026, Mollie). Stripe zeigte
 * sie im Kundenportal; Mollie hat keins. Das PDF holt ein Klick frisch bei
 * Mollie, weil dessen Links ablaufen. Ohne Rechnung steht hier nichts.
 */

import { useEffect, useState } from 'react';
import { ladeRechnungen, rechnungsLink, type Rechnung } from '../api';
import { Abschnitt, KleinerKnopf, Panel } from '../ui';
import { locale, t } from '../sprache';

const tag = (iso: string) => new Date(iso).toLocaleDateString(locale(), { day: '2-digit', month: 'long', year: 'numeric' });
const euro = (cent: number | null) => (cent == null ? '' : new Intl.NumberFormat(locale(), { style: 'currency', currency: 'EUR' }).format(cent / 100));

export default function Rechnungen({ neu }: { neu?: unknown }) {
  const [liste, setListe] = useState<Rechnung[]>([]);
  const [oeffnet, setOeffnet] = useState('');
  const [fehler, setFehler] = useState('');

  useEffect(() => { ladeRechnungen().then(setListe).catch(() => setListe([])); }, [neu]);

  async function oeffnen(id: string) {
    setOeffnet(id);
    setFehler('');
    try {
      window.open((await rechnungsLink(id)).url, '_blank', 'noopener');
    } catch (e) {
      setFehler((e as Error).message);
    } finally {
      setOeffnet('');
    }
  }

  if (!liste.length) return null;
  return (
    <Abschnitt titel={t('Rechnungen', 'Invoices')} zahl={liste.length} unter={fehler || t('Jede Rechnung kommt auch per Mail.', 'Every invoice also arrives by email.')}>
      <Panel>
        <ul className="m-0 list-none p-0">
          {liste.map(r => (
            <li key={r.id} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-linie-zart px-4 py-3 first:border-t-0 sm:px-5">
              <span className="min-w-0 text-[0.9375rem] text-text">
                {r.beschreibung ?? t('Rechnung', 'Invoice')}
                <span className="block text-[0.8125rem] text-text-hell tabular-nums">
                  {tag(r.created_at)}{r.rechnungsnummer ? ` · ${r.rechnungsnummer}` : ''}{r.brutto_cent != null ? ` · ${euro(r.brutto_cent)}` : ''}
                </span>
              </span>
              <KleinerKnopf type="button" onClick={() => void oeffnen(r.id)} disabled={!!oeffnet}>
                {oeffnet === r.id ? t('Einen Moment …', 'One moment …') : 'PDF'}
              </KleinerKnopf>
            </li>
          ))}
        </ul>
      </Panel>
    </Abschnitt>
  );
}
